import {PipeTransform, Pipe} from '@angular/core';
import {isStringMap} from '../facade/lang';
import {StringMapWrapper} from '../facade/collection';
import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';
export class I18nSelectPipe implements PipeTransform {
  transform(value: string, mapping: {[key: string]: string}): string {
    if (!isStringMap(mapping)) {
      throw new InvalidPipeArgumentException(I18nSelectPipe, mapping);
    }

    return StringMapWrapper.contains(mapping, value) ? mapping[value] : mapping['other'];
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'i18nSelect', pure: true}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
